import React, { useState } from "react";
import "./styles.scss";
import "./mobile.scss";
import {
  Button,
  ButtonIcon,
  FormCheck,
  FormHeader,
  InputBox,
  Link,
  SectionHeader,
  TopMenu,
} from "../../components";
import "react-notifications-component/dist/theme.css";
import { CheckValidity } from "../../utils/formValidity";
import { useDispatch } from "react-redux";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { notification } from "antd";
import { createNewAdsCompany } from "./services/adsSignup.service";
import { setAdsSession } from "../../utils";
import { setSignupUser } from "../AdsPlatform/redux/actions";

const AdsSignUp = (props) => {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [isAgree, setIsAgree] = useState(false);

  const [formData, setFormData] = useState({
    firstName: {
      key: "firstName",
      label: "First name",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "ex : John",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    email: {
      key: "email",
      label: "Working email address",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "example@email.com",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    contact: {
      key: "contact",
      label: "Contact no",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "+94",
        maxLength: 12,
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "+94",
    },
    password: {
      key: "password",
      label: "Password",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "password",
        placeholder: "**********",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const handleChange = async (event, inputIdentity) => {
    const updateNewProductForm = {
      ...formData,
    };

    updateNewProductForm[inputIdentity].value = event;
    let validityRes = await CheckValidity(
      inputIdentity,
      updateNewProductForm[inputIdentity].value,
      updateNewProductForm[inputIdentity].validation
    );

    if (validityRes) {
      updateNewProductForm[inputIdentity].isValid = validityRes.isValid;
      updateNewProductForm[inputIdentity].invalidReason = validityRes.reason;
      if (inputIdentity === "contact") {
        updateNewProductForm[inputIdentity].value.concat(event);
      } else {
        updateNewProductForm[inputIdentity].value = event;
      }
      updateNewProductForm[inputIdentity].touched = true;

      let formIsValid = false;
      for (let inputIdentifier in updateNewProductForm) {
        formIsValid =
          updateNewProductForm[inputIdentifier].valid && formIsValid;
      }
      setFormData(updateNewProductForm);
    }
  };

  //update input validation
  const updateInputValidationErrors = async () => {
    let df = { ...formData };
    let formIsValid = true;
    for (let itemKey of Object.keys(df)) {
      if (itemKey === "firstName" || itemKey === "firstName") {
        if (df[itemKey].value === "" || df[itemKey].invalidReason) {
          df[itemKey].touched = true;
          formIsValid = false;
        }
      }
    }
    await setFormData(df);
    return formIsValid;
  };

  const clearAll = () => {
    const updateForm = {
      ...formData,
    };
    for (let key in updateForm) {
      updateForm[key].value = "";
      updateForm[key].isValid = false;
      updateForm[key].touched = false;
    }
    setFormData(updateForm);
  };

  const onClickSave = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    let updateFormData = { ...formData };
    let isValid = await updateInputValidationErrors();
    if (isValid) {
      let body = {
        company_name: updateFormData.firstName.value,
        company_logo: "",
        company_website: "",
        working_email: updateFormData.email.value,
        password: updateFormData.password.value,
        contact_no: updateFormData.contact.value,
      };

      try {
        let res = await createNewAdsCompany(body);
        console.log("res", res);
        if (res?.data?.status) {
          setIsLoading(false);
          setAdsSession(res?.data?.token);
          clearAll();
          notification.success({
            message: "Success",
            description: "Your account has been created successfully.",
          });
          dispatch(setSignupUser(res?.data?.data));
          props.history.push("/ads/verification");
        } else {
          setIsLoading(false);
          notification.error({
            message: "Error",
            description: res?.data?.message || "Something went wrong.",
          });
        }
      } catch (error) {
        console.log("error", error);
      }
      setIsLoading(false);
    } else {
      setIsLoading(false);
      notification.error({
        message: "Error",
        description: "Please fill all the required fields correctly.",
      });
    }
  };

  // const dispatch = useDispatch();
  const updateNewProductForm = { ...formData };

  return (
    <>
      <div className={"ads-sign-up-wrapper"}>
        <div>
          <TopMenu
            data={{
              size: "sm",
              isLanguage: false,
              isLogo: false,
              isProfile: false,
            }}
          />
        </div>
        <div className={"asuw__main-wrp"}>
          <div className={"asuw__nagivator"}>
            <ButtonIcon
              data={{
                iconName: "h-wrrow-left",
                size: "md",
                type: "light",
              }}
              onClick={() => {
                props.history.push("/ads");
              }}
            />
            Back to home
          </div>
          <div className={"asuw__form"}>
            <div className={"asuwf__header-wrapper"}>
              <div className={"asuwf__hw-logo"}>
                <img
                  src={require("../../assets/img/logo_new.png")}
                  alt={"logo"}
                />
              </div>
              <FormHeader
                data={{
                  formHeader: "Create your account",
                  size: "md-md",
                }}
              />
              <SectionHeader
                data={{
                  title: "Join us and get started in just a few steps.",
                  size: "md-sm",
                }}
              />
            </div>
            <InputBox
              data={updateNewProductForm.firstName}
              onChange={async (e) => {
                e.preventDefault();
                await handleChange(
                  e.target.value,
                  updateNewProductForm.firstName.key
                );
              }}
            />
            <InputBox
              data={updateNewProductForm.email}
              onChange={async (e) => {
                e.preventDefault();
                await handleChange(
                  e.target.value,
                  updateNewProductForm.email.key
                );
              }}
            />
            <InputBox
              data={updateNewProductForm.contact}
              onChange={async (e) => {
                e.preventDefault();
                await handleChange(
                  e.target.value,
                  updateNewProductForm.contact.key
                );
              }}
            />
            <InputBox
              data={updateNewProductForm.password}
              onChange={async (e) => {
                e.preventDefault();
                await handleChange(
                  e.target.value,
                  updateNewProductForm.password.key
                );
              }}
            />
            <div className={"asufw__check"}>
              <FormCheck
                data={{
                  iconName: "check",
                  isSelect: isAgree,
                }}
                onClick={() => {
                  setIsAgree(!isAgree);
                }}
              />
              <div className={"asufw__c-title"}>
                I agree to the <span className={"terms"}>Terms of Service</span>{" "}
                and <span className={"privacy"}> Privacy Policy</span>
              </div>
            </div>
            <Button
              data={{
                btnName: "SIGN UP",
                buttonType:
                  updateNewProductForm.email.value === "" ||
                  updateNewProductForm.password.value === "" ||
                  !isAgree
                    ? "primary disabled"
                    : "primary",
                buttonSize: "lg",
                isLoading: isLoading,
              }}
              onClick={async (e) => {
                e.preventDefault();
                await onClickSave(e);
              }}
            />
            <div
              className={
                "d-flex flex-column justify-content-center align-items-center mt-3"
              }
            >
              <Link
                data={{
                  title: "Already have an account?",
                  link: "Sign In",
                }}
                onClick={() => {
                  props.history.push("/ads/sign-in");
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(AdsSignUp);
